import Vue from 'vue';
import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

const app = new Vue({
    el: "#form",
    data: {
        year: year,
        month: month,
        day: "",
        yearResult: "",
        monthResult: "",
        dayResult: "",
        area: area,
        country: "",
        countryResult: [],
        quantity: 0,
        tourdes: tourdes,
        tourcheck1: false,
        tourcheck2: false,
    },
    mounted: function (){
        var Today = new Date();
        this.yearResult = Today.getFullYear() + 1;
        this.monthResult = 12;
        if (day !== "") {
            this.changeDay();
            this.day = day;
        }

        if (country !== "") {
            this.changeCountry();
            this.country = country;
        }
    },
    watch:{
        tourdes:{
            handler:function(){
                this.quantity= this.tourdes.length;
            },
            deep:true
        }
    },
    methods:{
        changeDay: function(){
            if (this.year == "") {
                return false;
            }
            this.day = "";
            if (this.month == 1 || this.month == 3 || this.month == 5 || this.month == 7 || this.month == 8 || this.month == 10 || this.month == 12) {
                this.dayResult = 31;
            } else if (this.month == 2) {
                if (((this.year % 4) == 0 && (this.year % 100) != 0 ) || ((this.year % 400) == 0)) {
                    this.dayResult = 29;
                } else {
                    this.dayResult = 28;
                }
            } else {
                this.dayResult = 30;
            }
        },
        changeCountry: function(){
            this.country = "";
            this.countryResult = [];
            axios.get(url, {
                params: {
                    uid: this.area,
                }
            }).then((response) => { this.countryResult = response.data.data; }).catch(error => console.log(error));
        },
        checkForm: function(){
            if (this.tourcheck1 == false) {
                alert('請勾選同意敘述一');
                return false;
            }

            if (this.tourcheck2 == false) {
                alert('請勾選同意敘述二');
                return false;
            }
            this.$refs.form.submit(function( e ) {
                e.preventDefault();
            });
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/blogform.js